import { render, staticRenderFns } from "./Demographics.vue?vue&type=template&id=756c3c6c"
import script from "./Demographics.vue?vue&type=script&lang=js"
export * from "./Demographics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports